import { SESSIONS_COLUMN_ID } from "../constants";
import SessionsTableActionsCell from "./ActionsCell";
import SessionsTableCreatedAtCell from "./CreatedAtCell";
import SessionsTableExpiresAtCell from "./ExpiresAtCell";
import SessionsTableIpAddressCell from "./IpAddressCell";
import SessionsTableSessionIdCell from "./SessionIdCell";
import SessionsTableTypeCell from "./TypeCell";
import SessionsTableUserCell from "./UserCell";

export const SESSIONS_TABLE_CELLS = {
  [SESSIONS_COLUMN_ID.USER]: SessionsTableUserCell,
  [SESSIONS_COLUMN_ID.SESSION_ID]: SessionsTableSessionIdCell,
  [SESSIONS_COLUMN_ID.TYPE]: SessionsTableTypeCell,
  [SESSIONS_COLUMN_ID.IP_ADDRESS]: SessionsTableIpAddressCell,
  [SESSIONS_COLUMN_ID.CREATED_AT]: SessionsTableCreatedAtCell,
  [SESSIONS_COLUMN_ID.EXPIRES_AT]: SessionsTableExpiresAtCell,
  [SESSIONS_COLUMN_ID.ACTIONS]: SessionsTableActionsCell,
};
